import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Search, Library, Menu } from 'lucide-react';
import { useSidebarStore } from '../stores/sidebarStore';

export const MobileNav = () => {
  const { toggleSidebar } = useSidebarStore();

  const getNavLinkClass = ({ isActive }: { isActive: boolean }) => 
    `flex flex-col items-center gap-1 text-xs ${
      isActive ? 'text-white' : 'text-zinc-400'
    }`;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-zinc-900 border-t border-zinc-800 px-4 py-2 md:hidden z-40">
      <div className="flex items-center justify-around">
        <button 
          onClick={toggleSidebar} 
          className="flex flex-col items-center gap-1 text-xs text-zinc-400"
        >
          <Menu className="w-6 h-6" />
          <span>Menu</span>
        </button>
        <NavLink to="/" className={getNavLinkClass}>
          <Home className="w-6 h-6" />
          <span>Home</span>
        </NavLink>
        <NavLink to="/search" className={getNavLinkClass}>
          <Search className="w-6 h-6" />
          <span>Search</span>
        </NavLink>
        <NavLink to="/library" className={getNavLinkClass}>
          <Library className="w-6 h-6" />
          <span>Library</span>
        </NavLink>
      </div>
    </nav>
  );
};